/* THE DOGS · Cama + manta · Test product 10453344289068 */
(() => {
  'use strict';

  if (customElements.get('td-bed-atf')) return;

  class TDBedATF extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      try {
        this.config = JSON.parse(
          this.querySelector('[data-bed-config]').textContent
        );

        if (String(this.config.productId) !== '10453344289068') return;

        this.variants = this.config.variants.filter(
          (variant) =>
            Number.isSafeInteger(Number(variant.id)) &&
            Number.isFinite(Number(variant.price))
        );

        if (!this.variants.length) return;

        this.form = this.querySelector('[data-bed-form]');
        this.idInput = this.querySelector('[data-bed-variant-id]');
        this.addButton = this.querySelector('[data-bed-add]');
        this.addonInput = this.querySelector('[data-bed-addon-toggle]');
        this.optionInputs = [
          ...this.querySelectorAll('[data-bed-option]'),
        ];

        if (
          !this.form ||
          !this.idInput ||
          !this.addButton ||
          !this.optionInputs.length
        ) {
          return;
        }

        this.moneyFormat = new Intl.NumberFormat(
          this.config.locale || 'es-CL',
          {
            style: 'currency',
            currency: this.config.currency || 'CLP',
            maximumFractionDigits: 0,
          }
        );

        this.controller = new AbortController();
        this.busy = false;
        this.uncertain = false;

        this.bindEvents();

        this.variant =
          this.variantFromURL() ||
          this.variants.find(
            (variant) =>
              String(variant.id) ===
              String(this.config.selectedVariantId)
          ) ||
          this.variants[0];

        this.setOptions(this.variant);

        const native = this.querySelector('[data-bed-native-variant]');

        if (native) native.disabled = true;

        this.show('[data-bed-native]', false);

        this.idInput.disabled = false;

        this.show('[data-bed-options]', true);
        this.show('[data-bed-addon]', this.addonAvailable());

        this.dataset.ready = 'true';

        this.render(false);
        this.observeVisibility();
      } catch (error) {
        /*
         * Mantiene disponible el formulario nativo de cama individual
         * si la mejora JavaScript no puede iniciarse.
         */
        this.controller?.abort();
        this.controller = null;

        const native = this.querySelector(
          '[data-bed-native-variant]'
        );

        if (native) native.disabled = false;
        if (this.idInput) this.idInput.disabled = true;

        this.show('[data-bed-native]', true);
        this.show('[data-bed-options]', false);
        this.show('[data-bed-addon]', false);
        this.show('[data-bed-sticky]', false);

        delete this.dataset.ready;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;

      this.intersection?.disconnect();
      this.resize?.disconnect();
      this.modalObserver?.disconnect();

      cancelAnimationFrame(this.frame);
    }

    listen(target, name, callback, options = {}) {
      target.addEventListener(name, callback, {
        ...options,
        signal: this.controller.signal,
      });
    }

    bindEvents() {
      this.listen(this.form, 'submit', (event) =>
        this.submit(event)
      );

      const stage = this.querySelector(
        '[data-bed-gallery-stage]'
      );

      if (stage) {
        this.listen(
          stage,
          'touchstart',
          (event) => {
            this.touchStart =
              event.touches.length === 1 &&
              !event.target.closest('video')
                ? {
                    x: event.touches[0].clientX,
                    y: event.touches[0].clientY,
                  }
                : null;
          },
          { passive: true }
        );

        this.listen(
          stage,
          'touchend',
          (event) => {
            if (
              !this.touchStart ||
              !event.changedTouches.length
            ) {
              return;
            }

            const dx =
              event.changedTouches[0].clientX -
              this.touchStart.x;

            const dy =
              event.changedTouches[0].clientY -
              this.touchStart.y;

            this.touchStart = null;

            if (
              Math.abs(dx) > 45 &&
              Math.abs(dx) > Math.abs(dy) * 1.3
            ) {
              this.showMedia(
                this.mediaIndex + (dx < 0 ? 1 : -1)
              );
            }
          },
          { passive: true }
        );

        this.listen(
          stage,
          'touchcancel',
          () => {
            this.touchStart = null;
          },
          { passive: true }
        );
      }

      this.listen(this, 'change', (event) => {
        if (this.busy || this.uncertain) return;

        if (
          event.target.matches(
            '[data-bed-option], [data-bed-addon-toggle]'
          )
        ) {
          this.clearError();
          this.render(true);

          this.dispatchEvent(
            new CustomEvent('td:bed:selection-change', {
              bubbles: true,
              detail: {
                productId: this.config.productId,
                variant: this.variant,
                addonSelected: this.hasAddon(),
                total: this.total(),
              },
            })
          );
        }
      });

      this.listen(this, 'click', (event) => {
        const button = event.target.closest('button');

        if (!button) return;

        if (button.matches('[data-bed-sticky-add]')) {
          if (!this.addButton.disabled) {
            this.form.requestSubmit(this.addButton);
          }
        } else if (button.matches('[data-bed-prev]')) {
          this.showMedia(this.mediaIndex - 1);
        } else if (button.matches('[data-bed-next]')) {
          this.showMedia(this.mediaIndex + 1);
        } else if (
          button.matches('[data-bed-media-index]')
        ) {
          this.showMedia(
            Number(button.dataset.bedMediaIndex)
          );
        } else if (button.matches('[data-bed-size-open]')) {
          this.openDialog(
            '[data-bed-size-dialog]',
            button
          );
        } else if (button.matches('[data-bed-zoom]')) {
          const image = this.querySelector(
            '[data-bed-main-image]'
          );

          const zoom = this.querySelector(
            '[data-bed-zoom-image]'
          );

          if (image && zoom) {
            zoom.src = this.imageURL(
              this.activeMedia(),
              1800
            );

            zoom.alt = image.alt;
          }

          this.openDialog(
            '[data-bed-zoom-dialog]',
            button
          );
        } else if (
          button.matches('[data-bed-dialog-close]')
        ) {
          button.closest('dialog')?.close();
        }
      });

      this.querySelectorAll('dialog').forEach((dialog) => {
        this.listen(dialog, 'click', (event) => {
          if (event.target !== dialog) return;

          const rect = dialog.getBoundingClientRect();

          if (
            event.clientX < rect.left ||
            event.clientX > rect.right ||
            event.clientY < rect.top ||
            event.clientY > rect.bottom
          ) {
            dialog.close();
          }
        });

        this.listen(dialog, 'close', () => {
          this.dialogOpener?.focus({
            preventScroll: true,
          });

          this.updateSticky();
        });
      });

      this.listen(window, 'popstate', () => {
        if (this.busy) return;

        const variant = this.variantFromURL();

        if (variant) {
          this.setOptions(variant);
          this.render(false);
        }
      });

      this.listen(window, 'pageshow', () => {
        if (!this.busy) this.render(false);
      });

      this.listen(
        window,
        'scroll',
        () => this.scheduleSticky(),
        { passive: true }
      );

      this.listen(
        window,
        'resize',
        () => this.scheduleSticky(),
        { passive: true }
      );
    }

    money(cents) {
      return this.moneyFormat
        .format(Number(cents || 0) / 100)
        .replace(/\u00a0/g, ' ');
    }

    text(selector, value) {
      this.querySelectorAll(selector).forEach((element) => {
        element.textContent = value;
      });
    }

    show(selector, visible) {
      this.querySelectorAll(selector).forEach((element) => {
        element.hidden = !visible;
      });
    }

    optionsOf(variant) {
      return (
        variant.options ||
        [
          variant.option1,
          variant.option2,
          variant.option3,
        ].filter((value) => value != null)
      );
    }

    size(value) {
      return String(value || '')
        .trim()
        .split(/[\s-]/)[0]
        .toUpperCase();
    }

    addonAvailable() {
      return Boolean(
        this.config.addon?.available &&
          this.config.addon.id &&
          Number(this.config.addon.price) >= 0
      );
    }

    hasAddon() {
      return Boolean(
        this.addonAvailable() &&
          this.addonInput?.checked
      );
    }

    total() {
      return (
        Number(this.variant?.price || 0) +
        (this.hasAddon()
          ? Number(this.config.addon.price)
          : 0)
      );
    }

    variantFromURL() {
      const variantId = new URL(
        window.location.href
      ).searchParams.get('variant');

      return this.variants.find(
        (variant) => String(variant.id) === variantId
      );
    }

    setOptions(variant) {
      const values = this.optionsOf(variant);

      this.optionInputs.forEach((input) => {
        input.checked =
          input.value ===
          String(
            values[
              Number(input.dataset.optionPosition) - 1
            ]
          );
      });
    }

    selectedOptions() {
      return this.config.options.map((option, index) => {
        const input = this.optionInputs.find(
          (candidate) =>
            Number(candidate.dataset.optionPosition) ===
              Number(option.position || index + 1) &&
            candidate.checked
        );

        return input?.value;
      });
    }

    render(updateURL) {
      const values = this.selectedOptions();

      this.variant =
        this.variants.find((variant) =>
          this.optionsOf(variant).every(
            (value, index) =>
              String(value) === values[index]
          )
        ) || null;

      const size = this.size(values[0]);
      const color = values[1] || '';

      const measurements = {
        S: '60 cm · Peso orientativo: hasta 10 kg',
        M: '80 cm · Peso orientativo: 10–20 kg',
        L: '100 cm · Peso orientativo: 20–45 kg',
        XL: '114 cm · Peso orientativo: 45–75 kg',
      };

      this.text('[data-bed-size-label]', size);

      this.text(
        '[data-bed-size-detail]',
        measurements[size] ||
          'Consulta la guía de tallas'
      );

      this.text('[data-bed-color-label]', color);

      this.text(
        '[data-bed-composition]',
        `Cama ${size} · ${color}${
          this.hasAddon() ? ' + manta' : ''
        }`
      );

      this.text(
        '[data-bed-price]',
        this.money(this.total())
      );

      const cyberPriceLabel = this.querySelector(
        '[data-bed-cyber-price-label]'
      );

      if (cyberPriceLabel) {
        cyberPriceLabel.hidden = !(
          this.variant?.available &&
          Number(this.variant.compare_at_price || 0) >
            Number(this.variant.price || 0)
        );
      }

      const stickyCyberPriceLabel = this.querySelector(
        '[data-bed-sticky-cyber-price-label]'
      );

      if (stickyCyberPriceLabel) {
        stickyCyberPriceLabel.hidden = !(
          this.variant?.available &&
          Number(this.variant.compare_at_price || 0) >
            Number(this.variant.price || 0)
        );
      }

      this.text(
        '[data-bed-addon-price]',
        `+${this.money(
          this.config.addon?.price || 0
        )}`
      );

      this.text(
        '[data-bed-addon-total]',
        `Cama + manta: ${this.money(
          Number(this.variant?.price || 0) +
            Number(this.config.addon?.price || 0)
        )} total`
      );

      this.querySelector(
        '[data-bed-addon-card]'
      )?.classList.toggle(
        'is-selected',
        this.hasAddon()
      );

      this.idInput.value = this.variant
        ? String(this.variant.id)
        : '';

      /*
       * Una talla permanece seleccionable cuando existe al
       * menos un color disponible. Cambiar de talla nunca
       * sustituye silenciosamente el color elegido.
       */
      this.optionInputs.forEach((input) => {
        const position =
          Number(input.dataset.optionPosition) - 1;

        const available = this.variants.some(
          (variant) =>
            variant.available &&
            this.optionsOf(variant)[position] ===
              input.value &&
            (position === 0 ||
              this.optionsOf(variant)[0] === values[0])
        );

        input.disabled =
          this.busy ||
          this.uncertain ||
          !available;

        const label =
          input.closest('label') ||
          (input.id
            ? this.querySelector(
                `label[for="${CSS.escape(input.id)}"]`
              )
            : null);

        label?.classList.toggle(
          'is-unavailable',
          !available
        );

        if (label) {
          label.title = available
            ? input.value
            : `${input.value}: agotado en esta talla`;
        }
      });

      const unavailable = !this.variant?.available;

      this.text(
        '[data-bed-color-availability]',
        unavailable
          ? 'Esta combinación no está disponible. Elige otro color o talla.'
          : ''
      );

      this.show(
        '[data-bed-color-availability]',
        unavailable
      );

      if (this.addonInput) {
        this.addonInput.disabled =
          this.busy ||
          this.uncertain ||
          !this.addonAvailable();
      }

      const threshold = Number(
        this.config.freeShippingThreshold
      );

      const shippingEnabled =
        Boolean(this.config.freeShippingEnabled) &&
        threshold > 0 &&
        (this.config.currency || 'CLP') === 'CLP';

      const soloFree =
        shippingEnabled &&
        Number(this.variant?.price || 0) >= threshold;

      const combinedFree =
        shippingEnabled &&
        this.addonAvailable() &&
        Number(this.variant?.price || 0) +
          Number(this.config.addon.price) >=
          threshold;

      this.show(
        '[data-bed-shipping]',
        !unavailable && (soloFree || combinedFree)
      );

      this.show(
        '[data-bed-shipping-note]',
        !unavailable && (soloFree || combinedFree)
      );

      this.text(
        '[data-bed-shipping]',
        soloFree || this.hasAddon()
          ? 'Envío gratis'
          : 'Con manta, envío gratis'
      );

      const disabled =
        unavailable || this.busy || this.uncertain;

      const label = this.busy
        ? 'Agregando…'
        : this.uncertain
          ? 'Revisa tu carrito'
          : unavailable
            ? 'Elige una opción disponible'
            : `${
                this.hasAddon()
                  ? 'Agregar cama + manta'
                  : `Agregar cama ${size}`
              } — ${this.money(this.total())}`;

      this.addButton.disabled = disabled;

      this.addButton.setAttribute(
        'aria-disabled',
        String(disabled)
      );

      this.addButton.setAttribute(
        'aria-busy',
        String(this.busy)
      );

      this.text(
        '[data-bed-add-label], [data-bed-sticky-label]',
        label
      );

      const stickyButton = this.querySelector(
        '[data-bed-sticky-add]'
      );

      if (stickyButton) {
        stickyButton.disabled = disabled;
      }

      this.form.setAttribute(
        'aria-busy',
        String(this.busy)
      );

      if (this.variant) {
        if (updateURL) {
          const url = new URL(window.location.href);

          url.searchParams.set(
            'variant',
            String(this.variant.id)
          );

          /*
           * Algunas vistas previas restringen el historial.
           * La selección sigue funcionando en ese caso.
           */
          try {
            window.history.replaceState(
              window.history.state,
              '',
              url.toString()
            );
          } catch (error) {
            // Mantiene el estado actual del formulario.
          }
        }

        if (
          this.galleryVariant !==
          String(this.variant.id)
        ) {
          this.buildGallery(this.variant);
        }
      }

      this.scheduleSticky();
    }

    imageURL(media, width) {
      const source =
        media?.preview_image?.src ||
        media?.src ||
        '';

      if (!source) return '';

      const url = new URL(
        source,
        window.location.origin
      );

      if (
        !['https:', 'http:'].includes(url.protocol)
      ) {
        return '';
      }

      url.searchParams.set('width', String(width));

      return url.toString();
    }

    activeMedia() {
      return this.galleryMedia?.[this.mediaIndex];
    }

    buildGallery(variant) {
      const media = this.config.media || [];
      const featuredId = variant.featured_media?.id;

      let start = media.findIndex(
        (item) =>
          String(item.id) === String(featuredId)
      );

      if (start < 0) start = 0;

      const groupStarts = new Set(
        this.variants
          .map((item) =>
            String(item.featured_media?.id)
          )
          .filter((id) => id !== 'undefined')
      );

      let end = media.findIndex(
        (item, index) =>
          index > start &&
          groupStarts.has(String(item.id))
      );

      if (end < 0) end = media.length;

      this.galleryMedia = media
        .slice(start, end)
        .filter(
          (item) =>
            item.media_type === 'image' ||
            (item.media_type === 'video' &&
              item.sources?.some(
                (source) =>
                  source.mime_type === 'video/mp4' ||
                  source.format === 'mp4'
              ))
        );

      /*
       * Prioriza la demostración de la funda desmontable
       * dentro del grupo de imágenes de la variante.
       */
      const coverIndex = this.galleryMedia.findIndex(
        (item, index) =>
          index > 1 &&
          /funda[_\s-]*desmontable|cierre/i.test(
            item.alt ||
              item.preview_image?.src ||
              ''
          )
      );

      if (coverIndex > 1) {
        this.galleryMedia.splice(
          1,
          0,
          this.galleryMedia.splice(coverIndex, 1)[0]
        );
      }

      this.galleryVariant = String(variant.id);

      this.show(
        '[data-bed-gallery-navigation], [data-bed-thumbnails]',
        this.galleryMedia.length > 1
      );

      const thumbnails = this.querySelector(
        '[data-bed-thumbnails]'
      );

      if (thumbnails) {
        const fragment =
          document.createDocumentFragment();

        this.galleryMedia.forEach((item, index) => {
          const button =
            document.createElement('button');

          button.type = 'button';
          button.dataset.bedMediaIndex =
            String(index);
          button.dataset.bedThumbnail = '';

          button.setAttribute(
            'aria-label',
            `${
              item.media_type === 'video'
                ? 'Ver video'
                : 'Ver imagen'
            } ${index + 1}`
          );

          const image =
            document.createElement('img');

          image.src = this.imageURL(item, 120);
          image.alt = '';
          image.width = 52;
          image.height = 52;
          image.loading = 'lazy';
          image.decoding = 'async';

          button.append(image);

          if (item.media_type === 'video') {
            const play =
              document.createElement('span');

            play.textContent = '▶';
            play.setAttribute(
              'aria-hidden',
              'true'
            );

            button.append(play);
          }

          fragment.append(button);
        });

        thumbnails.replaceChildren(fragment);
      }

      this.showMedia(0);
    }

    showMedia(index) {
      if (!this.galleryMedia?.length) return;

      this.mediaIndex = Math.max(
        0,
        Math.min(
          index,
          this.galleryMedia.length - 1
        )
      );

      const media = this.activeMedia();
      const isVideo = media.media_type === 'video';

      const previousVideo = this.querySelector(
        '[data-bed-gallery-video]'
      );

      if (previousVideo) {
        previousVideo.pause();
        previousVideo.remove();
      }

      this.show('[data-bed-zoom]', !isVideo);
      this.show('[data-bed-main-image]', !isVideo);

      const image = this.querySelector(
        '[data-bed-main-image]'
      );

      if (isVideo) {
        const video =
          document.createElement('video');

        video.dataset.bedGalleryVideo = '';
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        video.poster = this.imageURL(media, 900);

        const sources = media.sources
          .filter(
            (source) =>
              source.mime_type === 'video/mp4' ||
              source.format === 'mp4'
          )
          .sort(
            (first, second) =>
              (second.height || 0) -
              (first.height || 0)
          );

        video.src = (
          sources.find(
            (source) => source.height <= 1080
          ) || sources[0]
        ).url;

        video.setAttribute(
          'aria-label',
          'Video del producto'
        );

        this.querySelector(
          '[data-bed-gallery-stage]'
        )?.append(video);
      } else if (image) {
        image.srcset = [
          360,
          540,
          750,
          1000,
          1400,
        ]
          .map(
            (width) =>
              `${this.imageURL(
                media,
                width
              )} ${width}w`
          )
          .join(', ');

        image.sizes =
          '(min-width: 990px) 620px, ' +
          '(min-width: 750px) 50vw, 100vw';

        image.src = this.imageURL(media, 1000);

        image.alt =
          media.alt ||
          `Cama ${this.size(
            this.optionsOf(this.variant)[0]
          )} · ${this.optionsOf(this.variant)[1]}`;
      }

      this.text(
        '[data-bed-counter]',
        `${this.mediaIndex + 1} / ${
          this.galleryMedia.length
        }`
      );

      this.querySelectorAll(
        '[data-bed-media-index]'
      ).forEach((button) => {
        button.setAttribute(
          'aria-current',
          String(
            Number(button.dataset.bedMediaIndex) ===
              this.mediaIndex
          )
        );
      });

      const previousButton = this.querySelector(
        '[data-bed-prev]'
      );

      const nextButton = this.querySelector(
        '[data-bed-next]'
      );

      if (previousButton) {
        previousButton.disabled =
          this.mediaIndex === 0;
      }

      if (nextButton) {
        nextButton.disabled =
          this.mediaIndex ===
          this.galleryMedia.length - 1;
      }
    }

    openDialog(selector, opener) {
      const dialog = this.querySelector(selector);

      if (
        !dialog ||
        typeof dialog.showModal !== 'function'
      ) {
        return;
      }

      this.dialogOpener = opener;
      dialog.showModal();
      this.updateSticky();
    }

    observeVisibility() {
      if ('IntersectionObserver' in window) {
        this.intersection =
          new IntersectionObserver(
            () => this.updateSticky(),
            { threshold: [0, 1] }
          );

        this.intersection.observe(this.addButton);
      }

      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() =>
          this.scheduleSticky()
        );

        this.resize.observe(this.form);
      }

      this.modalObserver = new MutationObserver(
        () => this.scheduleSticky()
      );

      this.modalObserver.observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'open'],
      });

      this.updateSticky();
    }

    scheduleSticky() {
      cancelAnimationFrame(this.frame);

      this.frame = requestAnimationFrame(() =>
        this.updateSticky()
      );
    }

    updateSticky() {
      const sticky = this.querySelector(
        '[data-bed-sticky]'
      );

      if (!sticky || !this.addButton) return;

      const rect =
        this.addButton.getBoundingClientRect();

      const viewport = window.innerHeight;

      const visible =
        rect.top >= 0 && rect.bottom <= viewport;

      const blocked = document.querySelector(
        'dialog[open], ' +
          'cart-drawer.active, ' +
          'cart-notification.active, ' +
          '.cart-drawer.is-open'
      );

      sticky.hidden =
        window.innerWidth >= 750 ||
        visible ||
        Boolean(blocked) ||
        !this.isConnected;
    }

    clearError() {
      this.text('[data-bed-error]', '');

      this.show(
        '[data-bed-error], [data-bed-cart-link]',
        false
      );
    }

    emit(name, detail = {}) {
      document.dispatchEvent(
        new CustomEvent(
          `td:product-form:submit-${name}`,
          {
            detail: {
              formId: this.form.id,
              ...detail,
            },
          }
        )
      );
    }

    cartURL() {
      return this.config.routes?.cart || '/cart';
    }

    async submit(event) {
      event.preventDefault();

      if (
        this.busy ||
        this.uncertain ||
        !this.variant?.available ||
        this.addButton.disabled
      ) {
        return;
      }

      this.clearError();

      this.busy = true;
      this.render(false);
      this.emit('start');

      const items = [
        {
          id: Number(this.variant.id),
          quantity: 1,
        },
      ];

      if (this.hasAddon()) {
        items.push({
          id: Number(this.config.addon.id),
          quantity: 1,
        });
      }

      const cart =
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-notification');

      let sectionIds = [];
      let failed = false;
      let accepted = false;

      try {
        if (cart?.getSectionsToRender) {
          sectionIds = cart
            .getSectionsToRender()
            .map((section) => section.id)
            .slice(0, 5);
        }

        cart?.setActiveElement?.(
          document.activeElement
        );

        const body = { items };

        if (sectionIds.length) {
          body.sections = sectionIds;
          body.sections_url =
            window.location.pathname;
        }

        let addURL =
          this.config.routes?.add ||
          '/cart/add.js';

        if (!/\.js(?:\?|$)/.test(addURL)) {
          addURL =
            addURL.replace(/\/$/, '') + '.js';
        }

        const response = await fetch(addURL, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        });

        let data;

        try {
          data = await response.json();
        } catch (error) {
          throw new Error(
            'No pudimos confirmar la respuesta. Revisa tu carrito antes de volver a agregar.'
          );
        }

        if (
          !response.ok ||
          Number(data.status) >= 400
        ) {
          const error = new Error(
            typeof data.description === 'string'
              ? data.description
              : 'No pudimos completar la selección. Revisa la disponibilidad y tu carrito.'
          );

          error.definitive =
            response.status >= 400 &&
            response.status < 500;

          throw error;
        }

        accepted = true;

        this.emit('success', {
          response: data,
        });

        this.text(
          '[data-bed-status]',
          'Tu selección se agregó al carrito.'
        );

        const completeSections =
          sectionIds.length &&
          sectionIds.every(
            (id) =>
              typeof data.sections?.[id] ===
                'string' &&
              data.sections[id].length
          );

        if (
          !cart?.renderContents ||
          !completeSections
        ) {
          window.location.assign(this.cartURL());
          return;
        }

        const first = data.items?.[0];

        cart.renderContents({
          ...data,
          id: data.id || first?.id,
          key: data.key || first?.key,
        });
      } catch (error) {
        failed = true;

        if (accepted) {
          /*
           * La selección ya está en el carrito.
           * No debe enviarse nuevamente.
           */
          window.location.assign(this.cartURL());
          return;
        }

        this.uncertain = !error.definitive;

        const message = error.definitive
          ? error.message
          : 'No pudimos confirmar si se agregó. Revisa tu carrito antes de volver a intentarlo.';

        this.text('[data-bed-error]', message);

        this.show(
          '[data-bed-error], [data-bed-cart-link]',
          true
        );

        this.querySelector(
          '[data-bed-error]'
        )?.focus({
          preventScroll: true,
        });

        this.emit('error', { message });
      } finally {
        this.busy = false;
        this.render(false);

        this.emit('end', {
          hasError: failed,
        });
      }
    }
  }

  customElements.define('td-bed-atf', TDBedATF);
})();